import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { ToastComponent } from '../../toast/toast.component';
import { OrganizationService } from '../../../services/organization.service';
import { Organization } from '../../models/organization.model';
import { ee, usernameRegexp } from '../../constants';
import { setClassInvalidTpl } from '../../functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-edit-organization-details-modal',
  templateUrl: './edit-organization-details-modal.component.html',
  standalone: false
})
export class EditOrganizationDetailsModalComponent implements OnInit, OnDestroy {
  toast = inject(ToastComponent);
  private organizationService = inject(OrganizationService);


  @Input() organization: Organization = {};
  @Input() field = '';

  usernameRegexp = usernameRegexp;
  setClassInvalidTpl = setClassInvalidTpl;

  ngOnInit(): void {
    // This is executed N+1 times, to fix eventually
    ee.on('showEditOrganizationDetailsModal', (field: string) => this.field = field);
  }

  ngOnDestroy(): void {
    ee.off('showEditOrganizationDetailsModal', () => {});
  }

  updateOrganization(field: string): void {
    const organization: Organization = {
      _id: this.organization._id,
      [field]: this.organization[field]
    };
    this.updateOrganizationService(organization);
  }

  updateOrganizationService(organization: Organization): void {
    this.organizationService.update(organization)
      .pipe(finalize(() => ee.emit('getOrganization')))
      .subscribe({
        next: res => this.toast.setMessage('Organization updated successfully', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
